<template>
  <li
    ref="group"
    class="vs-component vs-dropdown--group"
    :class="{
      marginIcon: vsCollapse,
      'no-cascading': !vsCollapse,
      'group-rightx': rightx,
    }"
    @click="toggleGroup"
  >
    <span v-if="vsCollapse" class="span vs-dropdown--group-label">
      {{ vsLabel }}
    </span>
    <h3 v-else>{{ vsLabel }}</h3>
    <vs-icon
      v-if="vsCollapse"
      class="icon-group notranslate vs-dropdown--group-icon"
      :icon-pack="iconPack"
      :icon="vsIcon"
    />
    <div
      ref="items"
      class="con-dropdown--group-con-ul"
      :class="{ 'con-dropdown-group-no-cascading': !vsCollapse }"
      :style="{ maxHeight: vsCollapse ? maxHeight : 'auto' }"
    >
      <ul class="con-dropdown--group-ul"><slot /></ul>
    </div>
  </li>
</template>

<script>
export default {
  name: "VsDropdownGroup",
  props: {
    vsLabel: {
      type: String,
      default: "Options",
    },
    vsCollapse: {
      type: Boolean,
      default: false,
    },
    vsIcon: {
      type: String,
      default: "keyboard_arrow_right",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
  },
  data() {
    return {
      rightx: false,
      maxHeight: "0px",
    };
  },
  methods: {
    toggleGroup(event) {
      if (!this.vsCollapse || event.target !== this.$refs.group) return;
      const height = this.$refs.items.scrollHeight;
      if (this.maxHeight === "0px") {
        this.maxHeight = `${height}px`;
        setTimeout(() => {
          this.maxHeight = "none";
        }, 300);
      } else {
        this.maxHeight = `${height}px`;
        setTimeout(() => {
          this.maxHeight = "0px";
        }, 50);
      }
    },
  },
};
</script>
